import Breadcrumb from "components/Common/Breadcrumb"
import React, { useState } from "react"
import { Link, useNavigate } from "react-router-dom"
import {
  Card,
  CardBody,
  Container,
  Form,
  Input,
  Label,
  Modal,
  Row,
} from "reactstrap"
import Select from "react-select"
// editor
import { CKEditor } from "@ckeditor/ckeditor5-react"
import ClassicEditor from "@ckeditor/ckeditor5-build-classic"
import { FetchNodePostData } from "utils/common-fetchData" // Added import
import secureLocalStorage from "react-secure-storage" // Added import
import Swal from "sweetalert2" // Added import
import Loader from "pages/Separate/Loader" // Added import
import { copyToClipBoard } from "pages/Separate/copyText"
import { Editor } from "@tinymce/tinymce-react"

const ContractAddTemplate = () => {
  const colourStyles = {
    menuList: styles => ({
      ...styles,
      background: "white",
    }),
    menu: base => ({
      ...base,
      zIndex: 1200,
    }),
  }

  const [fixButtons, setFixButtons] = useState(false)
  const [edit_status, setEditStatus] = useState(false)
  const [loading, setLoading] = useState(false) // Added for API call
  const [templateData, setTemplateData] = useState({
    name: "",
    description: "<p></p>",
  }) // Added for form data
  const navigate = useNavigate()

  const handleSave = async () => {
    try {
      setLoading(true)
      const formData = {
        name: templateData.name,
        description: templateData.description.getContent(),
      }
      const response = await FetchNodePostData(
        setLoading,
        `postContract/contract-template`,
        secureLocalStorage?.getItem("auth_token"),
        formData
      )
      if (response.status === 200) {
        Swal.fire({
          icon: "success",
          text: "Contract Template Added Successfully",
          showConfirmButton: true,
        })
        navigate("/setting/contract")
      } else {
        Swal.fire({
          icon: "error",
          text: response.data?.message || "Failed to add contract template",
          showConfirmButton: true,
        })
      }
    } catch (err) {
      console.error("Error adding contract template:", err)
      Swal.fire({
        icon: "error",
        text:
          err.message || "An error occurred while adding the contract template",
        showConfirmButton: true,
      })
    } finally {
      setLoading(false)
    }
  }

  document.addEventListener("scroll", () => {
    if (window.scrollY > 160) {
      setFixButtons(true)
    } else {
      setFixButtons(false)
    }
  })

  const handleEditorChange = (content, editor) => {
    setTemplateData({
      ...templateData,
      description: editor,
    })
  }



  return (
    <div>
      {loading && <Loader />}
      <React.Fragment>
        <div className="page-content mb-4">
          <Container fluid>
            <Breadcrumb title="Dashboard" breadcrumbItem="Contract Template" />
            <Row className="gx-4 justify-content-between di-flex align-items-top">
              <div
                className={`flex-column fixed-buttons ${fixButtons ? "d-flex" : "d-none"
                  }`}
              >
                <button
                  className="btn btn-purple border-radius fix-btn"
                  onClick={handleSave} // Added onClick handler
                >
                  <i className="fas fa-save me-2"></i>
                  <span>Save</span>
                </button>
                <a
                  onClick={() => navigate(-1)}
                  className="btn btn-red border-radius fix-btn"
                >
                  <i className="dripicons-cross me-2 icon-center"></i>
                  <span>Cancel</span>
                </a>
              </div>

              <Card>
                <CardBody>
                  <div className="mb-20">
                    <Row>
                      <div className="col-md-6">
                        <h4>Add Contract Template</h4>
                      </div>
                      <div className="col-md-6 text-md-end">
                        <button
                          className="border-radius btn text-white me-md-0 me-2 btn-purple"
                          onClick={handleSave} // Added onClick handler
                        >
                          <i className="fas fa-save me-2"></i>SAVE
                        </button>
                        <a
                          className="border-radius btn text-white ms-md-2 btn-red"
                          onClick={() => navigate(-1)}
                        >
                          <i className="dripicons-cross me-2 icon-center"></i>
                          CANCEL
                        </a>
                      </div>
                    </Row>
                  </div>
                  <Form className="row align-items-end">
                    <div className="mb-3 col-md-3">
                      <Label htmlFor="formrow-firstname-Input">Name</Label>
                      <Input
                        type="text"
                        className="form-control"
                        id="formrow-firstname-Input"
                        placeholder="Enter Name"
                        value={templateData.name} // Controlled input
                        onChange={e =>
                          setTemplateData({
                            ...templateData,
                            name: e.target.value,
                          })
                        }
                      />
                    </div>
                    <div className="mb-3 col-md-3">
                      <a
                        className="border-radius btn text-white me-md-0 me-2 btn-purple"
                        onClick={() => {
                          setEditStatus(true)
                        }}
                      >
                        Dynamic Fields
                      </a>
                    </div>
                    <div className="mb-3 col-md-12">
                      <Label htmlFor="formrow-firstname-Input">
                        Description
                      </Label>
                      {/* <CKEditor
                        editor={ClassicEditor}
                        placeholder="Enter Description"
                        data={templateData.description}
                        onChange={(event, editor) => {
                          const data = editor.getData()
                          setTemplateData({
                            ...templateData,
                            description: data,
                          })
                        }}
                      /> */}
                      <Editor
                        initialValue={templateData?.description}
                        apiKey="w6fz9u4rgsouz7jqcyy4lflpolp0tjwkx1bzoc70ntetxwys"
                        init={{
                          height: 800,
                          menubar: true,
                          plugins: [
                            "a11ychecker",
                            "accordion",
                            "advlist",
                            "advcode",
                            "advtable",
                            "autolink",
                            "checklist",
                            "export",
                            "lists",
                            "link",
                            "image",
                            "charmap",
                            "anchor",
                            "searchreplace",
                            "visualblocks",
                            "powerpaste",
                            "fullscreen",
                            "formatpainter",
                            "insertdatetime",
                            "media",
                            "table",
                            "wordcount",
                            "code",
                            "pagebreak",
                            "quickbars",
                            "codesample",
                            "textcolor",
                          ],
                          toolbar:
                            "undo redo | casechange blocks | bold italic backcolor | fontselect fontsizeselect |" +
                            "alignleft aligncenter alignright alignjustify | " +
                            "bullist numlist checklist outdent indent | removeformat | a11ycheck code table | exportpdf |",
                          fontsize_formats:
                            "8pt 10pt 12pt 14pt 18pt 24pt 36pt",
                        }}
                        // onEditorChange={handleEditorInit}
                        onEditorChange={handleEditorChange}
                      />
                    </div>
                  </Form>
                </CardBody>
              </Card>
            </Row>
          </Container>
        </div>

        <Modal
          isOpen={edit_status}
          size="lg"
          className=""
          centered
        >
          <div className="modal-header">
            <h5 className="modal-title mt-0">Dynamic fields</h5>
            <button
              type="button"
              onClick={() => {
                setEditStatus(false)
              }}
              className="btn-modal-close"
            >
              <span aria-hidden="true" className="btn-modal-span">
                ×
              </span>
            </button>
          </div>
          <div className="modal-body">
            <Row>
              <div className="d-flex flex-wrap position-relative">
                <div className="col-6 px-3 align-items-center d-flex justify-content-center px-1 mb-2 ">
                  <label htmlFor="" className="col-4 mb-0">
                    Company Name
                  </label>
                  <div className="p-2 me-3 col-5 bg-dynamic-field">
                    {"$client_company"}
                  </div>
                  <button
                    onClick={() => copyToClipBoard(0)}
                    value="$client_company"
                    className="p-2 fas fa-copy copyBtn h-100 col-2 btn btn-primary  btn-sm"
                  ></button>
                </div>
                <div className="col-6 px-3 align-items-center d-flex justify-content-center px-1 mb-2">
                  <label htmlFor="" className="col-4 mb-0">
                    Client Name
                  </label>
                  <div className="p-2 me-3 col-5 bg-dynamic-field">
                    {"$client_name"}
                  </div>
                  <button
                    onClick={() => copyToClipBoard(1)}
                    value="$client_name"
                    className="p-2 fas fa-copy copyBtn h-100 col-2 btn-sm btn btn-primary btn-sm"
                  ></button>
                </div>
                <div className="col-6 px-3 align-items-center d-flex justify-content-center px-1 mb-2">
                  <label htmlFor="" className="col-4 mb-0">
                    Address
                  </label>
                  <div className="p-2 me-3 col-5 bg-dynamic-field">
                    {"$client_address"}
                  </div>
                  <button
                    onClick={() => copyToClipBoard(2)}
                    value="$client_address"
                    className="p-2 fas fa-copy copyBtn h-100 col-2 btn btn-primary btn-sm"
                  ></button>
                </div>
                <div className="col-6 px-3 align-items-center d-flex justify-content-center px-1 mb-2">
                  <label htmlFor="" className="col-4 mb-0">
                    State
                  </label>
                  <div className="p-2 me-3 col-5 bg-dynamic-field">
                    {"$client_state"}
                  </div>
                  <button
                    onClick={() => copyToClipBoard(3)}
                    value="$client_state"
                    className="p-2 fas fa-copy copyBtn h-100 col-2 btn btn-primary btn-sm"
                  ></button>
                </div>
                <div className="col-6 px-3 align-items-center d-flex justify-content-center px-1 mb-2">
                  <label htmlFor="" className="col-4 mb-0">
                    Contract Value
                  </label>
                  <div className="p-2 me-3 col-5 bg-dynamic-field">
                    {"$contract_value"}
                  </div>
                  <button
                    onClick={() => copyToClipBoard(4)}
                    value="$contract_value"
                    className="p-2 fas fa-copy copyBtn h-100 col-2 btn btn-primary btn-sm"
                  ></button>
                </div>
                <div className="col-6 px-3 align-items-center d-flex justify-content-center px-1 mb-2">
                  <label htmlFor="" className="col-4 mb-0">
                    Current Date
                  </label>
                  <div className="p-2 me-3 col-5 bg-dynamic-field">
                    {"$current_date"}
                  </div>
                  <button
                    onClick={() => copyToClipBoard(5)}
                    value="$current_date"
                    className="p-2 fas fa-copy copyBtn h-100 col-2 btn btn-primary btn-sm"
                  ></button>
                </div>
                <div className="col-6 px-3 align-items-center d-flex justify-content-center px-1 mb-2">
                  <label htmlFor="" className="col-4 mb-0">
                    Start Date
                  </label>
                  <div className="p-2 me-3 col-5 bg-dynamic-field">
                    {"$start_date"}
                  </div>
                  <button
                    onClick={() => copyToClipBoard(6)}
                    value="$start_date"
                    className="p-2 fas fa-copy copyBtn  h-100 col-2 btn btn-primary btn-sm"
                  ></button>
                </div>
                <div className="col-6 px-3 align-items-center d-flex justify-content-center px-1 mb-2">
                  <label htmlFor="" className="col-4 mb-0">
                    End Date
                  </label>
                  <div className="p-2 col-5 me-3 bg-dynamic-field">
                    {"$end_date"}
                  </div>
                  <button
                    onClick={() => copyToClipBoard(7)}
                    value="$end_date"
                    className="p-2 col-2 fas fa-copy copyBtn h-100 btn btn-primary btn-sm"
                  ></button>
                </div>
                <div className="copy-modal-line"></div>
              </div>
            </Row>
          </div>
        </Modal>
      </React.Fragment>
    </div>
  )
}

export default ContractAddTemplate
